import { render, staticRenderFns } from "./dvn_gdp.vue?vue&type=template&id=6355c645&scoped=true"
import script from "./dvn_gdp.vue?vue&type=script&lang=js"
export * from "./dvn_gdp.vue?vue&type=script&lang=js"
import style0 from "./dvn_gdp.vue?vue&type=style&index=0&id=6355c645&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6355c645",
  null
  
)

export default component.exports